import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React from "react";
import { DateRange } from "react-day-picker";
import { RELATIVE_OPTIONS } from "../../utils/constants";
import { DateFilterValue } from "../../utils/interfaces";
import { DateRangePicker } from "./DateRangePicker";

interface DateFilterProps {
  disableFuture?: boolean;
  value: DateFilterValue;
  onChange: (val: DateFilterValue) => void;
  title: string;
}

export const DateFilter: React.FC<DateFilterProps> = ({
  disableFuture,
  value,
  onChange,
  title,
}) => {
  const isRangeSet = !!(value.range?.from && value.range?.to);
  const isRelativeSet = !!value.relativeValue;

  const handleRangeChange = (range: DateRange | undefined) => {
    onChange({
      range,
      relativeValue: undefined,
    });
  };

  return (
    <div
      className='space-y-5 w-72 text-black text-base font-medium'
      data-testid='dateFilter'
    >
      <div className='space-y-1.5'>
        <div data-testid='dateFilterLabel'>{title}</div>
        <Autocomplete
          options={RELATIVE_OPTIONS}
          disableClearable={false}
          size='small'
          value={
            value.relativeValue
              ? RELATIVE_OPTIONS.find(
                  (opt) => opt.id === value.relativeValue,
                ) ?? null
              : null
          }
          onChange={(_, newValue) =>
            onChange({
              range: undefined,
              relativeValue: newValue?.id,
            })
          }
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder='Select relative date'
              variant='outlined'
              data-testid='relativeSelect'
            />
          )}
          disabled={isRangeSet}
        />
      </div>
      <div className='space-y-1.5'>
        <div data-testid='selectDateLabel'>Select Date</div>
        <DateRangePicker
          value={value.range}
          onChange={handleRangeChange}
          disableFuture={disableFuture}
          disabled={isRelativeSet}
        />
      </div>
    </div>
  );
};
